import { render } from "./ControlloAcquistatoVenduto.vue?vue&type=template&id=091dca05&scoped=true"
import script from "./ControlloAcquistatoVenduto.vue?vue&type=script&lang=js"
export * from "./ControlloAcquistatoVenduto.vue?vue&type=script&lang=js"

import "./ControlloAcquistatoVenduto.vue?vue&type=style&index=0&id=091dca05&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091dca05"]])

export default __exports__